import script from "./CreatePostNewsfeedModal.vue?vue&type=script&setup=true&lang=js"
export * from "./CreatePostNewsfeedModal.vue?vue&type=script&setup=true&lang=js"

import "./CreatePostNewsfeedModal.vue?vue&type=style&index=0&id=75e54a9d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75e54a9d"]])

export default __exports__